import { unitFilterButtonClass } from '@/lib/unitColors'
import { useAllUnits } from '@/hooks/useUnits'

interface UnitFilterPillsProps {
  units: string[]
  selected: string
  onSelect: (unit: string) => void
  includeAll?: boolean
  className?: string
}

export default function UnitFilterPills({
  units,
  selected,
  onSelect,
  includeAll = true,
  className,
}: UnitFilterPillsProps) {
  const allDbUnits = useAllUnits()
  const dbTypeMap = new Map(allDbUnits.map(u => [u.name, u.unit_type?.name ?? '']))
  const getType = (name: string) => dbTypeMap.get(name) || ''
  const dbNames = new Set(allDbUnits.map(u => u.name))
  const unknown = units.filter(n => !dbNames.has(n))
  if (unknown.length > 0) {
    console.error(`[UnitFilterPills] Unknown units not in units table (data integrity issue): ${unknown.join(', ')}`)
  }
  const sorted = [
    ...allDbUnits.filter(u => units.includes(u.name)).map(u => u.name),
    ...unknown.sort(),
  ]
  const opts = includeAll ? ['All', ...sorted] : sorted

  return (
    <>
      <div role="group" aria-label="Filter by unit" className={`hidden md:flex gap-1.5 overflow-x-auto pb-1${className ? ' ' + className : ''}`}>
        {opts.map(u => (
          <button
            key={u}
            onClick={() => onSelect(u)}
            aria-pressed={selected === u}
            className={`px-2.5 py-1 rounded text-xs font-medium whitespace-nowrap flex-shrink-0 transition-colors ${
              unitFilterButtonClass(u === 'All' ? 'All' : getType(u), selected === u)
            }`}
          >
            {u}
          </button>
        ))}
      </div>
      <select
        aria-label="Filter by unit"
        value={selected}
        onChange={e => onSelect(e.target.value)}
        className={`md:hidden w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-1 focus:ring-red-500${className ? ' ' + className : ''}`}
      >
        {opts.map(u => <option key={u} value={u}>{u}</option>)}
      </select>
    </>
  )
}
